export enum SERVICE_STATUS {
	New = 1,
	Pending = 2,
	Modified = 3,
	OnProccess = 4,
	OnParchuseOrder = 5,
	Invoiced = 6,
	Submitted = 7,
}